import { render, staticRenderFns } from "./EfficiencySort.vue?vue&type=template&id=4e3e606e&scoped=true&"
import script from "./EfficiencySort.vue?vue&type=script&lang=js&"
export * from "./EfficiencySort.vue?vue&type=script&lang=js&"
import style0 from "./EfficiencySort.vue?vue&type=style&index=0&id=4e3e606e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e606e",
  null
  
)

export default component.exports